<template>
  <div class="stack">
    <h1>Réinitialiser le mot de passe</h1>

    <div v-if="stage==='verify'">Vérification du lien…</div>

    <div v-else>
      <p v-if="email">Compte : <strong>{{ email }}</strong></p>

      <form @submit.prevent="onSubmit" class="stack">
        <input
          v-model="password"
          type="password"
          placeholder="Nouveau mot de passe"
          required
          minlength="6"
        />
        <button :disabled="loading">{{ loading ? 'Validation…' : 'Valider' }}</button>
      </form>

      <p v-if="done" class="ok">Mot de passe mis à jour. Vous pouvez vous connecter.</p>
      <p v-if="error" class="error">{{ error }}</p>
    </div>
  </div>
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { verifyResetCode, applyNewPassword } from '@/service/auth_service';

    //Ne marche pas en history hash
    // const params = new URLSearchParams(window.location.search);
    // const oobCode = params.get('oobCode') || '';
    // const mode = params.get('mode'); // doit être "resetPassword"

    const hash = window.location.hash || '';
    const queryAfterHash = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(queryAfterHash);

    const oobCode = params.get('oobCode') || '';
    const mode = params.get('mode') || '';

    const stage = ref('verify'); // 'verify' | 'ready'
    const email = ref('');
    const password = ref('');
    const loading = ref(false);
    const done = ref(false);
    const error = ref('');

    onMounted(async () => {
    if (mode !== 'resetPassword' || !oobCode) {
        error.value = 'Lien invalide.';
        return;
    }
    try {
        email.value = await verifyResetCode(oobCode);
        stage.value = 'ready';
    } catch (e) {
        console.error('verifyResetCode error', e);
        error.value = 'Lien invalide ou expiré. Merci de relancer la procédure.';
    }
    });

    async function onSubmit() {
    loading.value = true;
    error.value = '';
    try {
        await applyNewPassword(oobCode, password.value);
        done.value = true;
    } catch (e) {
        console.error('applyNewPassword error', e);
        error.value = 'Impossible de mettre à jour le mot de passe.';
    } finally {
        loading.value = false;
    }
    }
</script>

<style scoped>
.stack { display:flex; flex-direction:column; gap:.75rem; max-width:360px; }
.ok { color:#2e7d32; }
.error { color:#b00020; }
</style>
